import { Fragment, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { SafeDatatable } from "../../components/SafeDatatable";
//import ReactDatatable from "@ashvin27/react-datatable";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

import _ from 'lodash';

import { DatasetDefault, DatasetModel } from "../../models/dataset.model";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../models/requestInputOutputParams.model";

import { ErrorHandler } from "../../services/errorHandler.service";
import { ToastService } from "../../services/toast.service";
import { TransporterService } from "../../services/transporter.service"; 
import { FileExportService } from "../../services/fileExport.service";
import storageService from "../../services/storage.service";
import { HeaderList } from "../../components/HeaderList";
import { CustomModal } from "../../components/Modal";
import DropdownButtonExport from "../../components/dropdownButton/export";
import { ButtonClean, ButtonSearch } from "../../components/buttons";
import UtilService from "../../services/util.service";
 
const TransporterList = () => {
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const [data, setData] = useState<DatasetModel>();
  const [showRemoveModal, setShowRemoveModal] = useState({
    id: 0,
    show: false,
    name: "",
    entity: undefined
  });
  const history = useHistory();
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)), dataset: 'transporter', filters: {
      fullname: [],
      document: []
    },
    sort: {
      field: 'fullName',
      orientation: 'asc'
    }
  });

  const user = storageService.getUser();

  const columns = [
    {
      key: "fullName",
      text: t(`TRANSPORTER.FULLNAME`),
      align: "left",
      sortable: true,
    },
    {
      key: "document",
      text: t(`TRANSPORTER.DOCUMENT`),
      align: "left",
      sortable: true,
    },
    {
      key: "action",
      text: t(`ACTIONS`),
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Dropdown className='btn-toolbar'>
              <Dropdown.Toggle
                as={Button}
                variant='primary'
                size='sm'
                className='me-2'>
                <FontAwesomeIcon icon={faCogs} className='me-2' />
              </Dropdown.Toggle>
              <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => history.push(`${pathname}/edit/${record.id}`)}>
                  <FontAwesomeIcon icon={faEdit} className='me-2' /> 
                  {(user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") ? (
                        t("VIEW")
                      ):
                        t("EDIT")
                  }
                </Dropdown.Item>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => actionRemove(record.id, record.fullName, record)}
                  disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  >
                  <FontAwesomeIcon icon={faTrash} className='me-2' /> {t('DELETE')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];
  
  const getList = async (dataTable, datasetOverride = null) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetOverride ||dataset] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    let sort = requestParams.datasets[0].sort;
    if (!sort) {
        sort = requestParams.datasets[0].sort = {};
    }
    if (!sort.field || sort.field === null || sort.field.trim?.() === "") {
        sort.field = "fullName";
    }
    if (!sort.orientation || sort.orientation === null || sort.orientation.trim?.() === "") {
        sort.orientation = "asc";
    }

    const response: any = await TransporterService.getList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'transporter' }));
      setData(d);
    } else {
      requestParams.datasets[0].data = null;
      setData(requestParams.datasets[0]);
    }
    setLoading(false);
  };

  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();

    const trimfullname = dataset.filters.fullname?.[0]?.trim() || "";
    const trimdocument = dataset.filters.document?.[0]?.trim() || "";

    const cleanedDataset = {
      ...dataset,
      filters: {
        ...dataset.filters,
        fullname: [trimfullname],
        document: [trimdocument],
      },
    };

    await getList(null,cleanedDataset);
  };

  const tableChangeHandler = async (data) => {
    await getList(data);
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

  const handleClean = (e) => {
    setDataset({
      ...dataset, filters: {
        fullname: [],
        document: []
      },
        sort: {
        field: "",
        orientation: "",
      },      
    });
    setFlagClear(true);
  };

  const actionRemove = (id, name, entity) => {
    setShowRemoveModal({ id: id, show: true, name: name, entity });
  };

  const handleCloseModal = () =>
    setShowRemoveModal({ id: 0, show: false, name: "", entity: null });

  const remove = async () => {
    if (showRemoveModal.id) {
      try {
        const response: any = await TransporterService.del(showRemoveModal.entity);
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t('TRANSPORTER.REMOVED'));
            await getList(null);
            handleClean(null);
            handleCloseModal();
          }
        }
      } catch (error) { }
    }
  };


  const initialize = async () => {
    await getList(null);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderList path={`${pathname}/add`} title={t(`TRANSPORTER.TITLE`)} disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

      <CustomModal
        Title={t('DELETE')}
        Message={`${t('TRANSPORTER.REMOVE_ANSWER')} ${showRemoveModal ? showRemoveModal.name : ""}?`}
        close={handleCloseModal}
        cancel={t('CANCEL')}
        show={showRemoveModal ? showRemoveModal.show : false}>
        <Button variant='primary' onClick={remove}>
          {t('YES')}
        </Button>
      </CustomModal>

      <Form>
        <Form.Label>{t('FILTERS')}</Form.Label>
        <Row>

          <Col sm={12} md={4} lg={3}>
            <Form.Group>
              <Form.Control
                name='fullname'
                id='fullname'
                type='text'
                placeholder={t(`TRANSPORTER.FULLNAME`)}
                className='form-control'
                onChange={(e) => {
                  setDataset({ ...dataset, filters: { ...dataset.filters, fullname: [e.target.value] } })
                }}
                value={dataset?.filters?.fullname.length > 0 ? dataset.filters.fullname[0] : ''}
              />
            </Form.Group>
          </Col>

          <Col sm={12} md={4} lg={3}>
            <Form.Group>
              <Form.Control
                name='document'
                id='document'
                type='text'
                placeholder={t(`TRANSPORTER.DOCUMENT`)}
                className='form-control'
                onChange={(e) => {
                  setDataset({ ...dataset, filters: { ...dataset.filters, document: [e.target.value] } })
                }}
                value={dataset?.filters?.document.length > 0 ? dataset.filters.document[0] : ''}
              />
            </Form.Group>
          </Col>

          <Col xs="auto">

            <ButtonSearch onClick={(e) => handleSearch(e)} />

          </Col>

          <Col xs="auto">

            <ButtonClean onClick={async (e) => {e.preventDefault(); handleClean(e);}} />

          </Col>

          <Col xs="auto">

            <DropdownButtonExport onClick={(type: string) =>
              FileExportService.Export(
                { ...RequestInputOutputParamsModelDefault, datasets: [dataset] },
                "Transporter",
                type
              )}
            />

          </Col>

        </Row>
      </Form>

      <SafeDatatable
        key={flagClear ? "reset" : JSON.stringify(dataset.filters)}
        config={UtilService.verifyIdiomDataTable()}
        records={data?.data ? data?.data : []}
        columns={columns}
        dynamic={true}
        total_record={data?.pagination?.total_records ? data?.pagination?.total_records : 0}
        onChange={tableChangeHandler}
        className='table table-hover user-table align-items-center'
      />

    </>
  );
};

export default TransporterList;